import { SelectList } from "api/baseApiResponseModel/BaseApiResponseModel";
import { strings } from "utils/localizedStrings";
import { TransactionStatusEnum, TransactionTypeEnum } from "../models/AppTransactionResponseModel";

export const statusOption: SelectList[] = [
  { label: strings.GlobalLabels.All, value: "" },
  { label: strings.AppTransactionHistory.Status.Init, value: TransactionStatusEnum.Init, color: "black" },
  { label: strings.AppTransactionHistory.Status.Process, value: TransactionStatusEnum.Proccess, color: "purple" },
  { label: strings.AppTransactionHistory.Status.Success, value: TransactionStatusEnum.Success, color: "green" },
  { label: strings.AppTransactionHistory.Status.Failed, value: TransactionStatusEnum.Failed, color: "red" },
  { label: strings.AppTransactionHistory.Status.Pending, value: TransactionStatusEnum.Pending, color: "orange" },
  { label: strings.AppTransactionHistory.Status.PaymentSuccess, value: TransactionStatusEnum.PaymentSuccess, color: "blue" },
  { label: strings.AppTransactionHistory.Status.Timeout, value: TransactionStatusEnum.Timeout, color: "orange" },
  { label: strings.AppTransactionHistory.Status.Deleted, value: TransactionStatusEnum.Deleted, color: "red" }
];

export const typeOption: SelectList[] = [
  { label: strings.GlobalLabels.All, value: "" },
  { label: strings.AppTransactionHistory.Type.Normal, value: TransactionTypeEnum.Normal },
  { label: strings.AppTransactionHistory.Type.User, value: TransactionTypeEnum.User },
  { label: strings.AppTransactionHistory.Type.Partner, value: TransactionTypeEnum.Partner },
];